<template>
  <div style="flex-grow:1">
    <div class="radio-form-item__top-content">
      <div>
        <h4>Überführung auf eigener Achse</h4>
        <p class="radio-form-item__price" v-if="price === 0">€ {{ price }} ,- </p>
        <p class="radio-form-item__price" v-else>ab € {{ price }} ,-  <span class="mwst block">inkl. Mwst.</span></p>
      </div>
    </div>
    <p class="delivery-form__note">
      Bei winterlichen Bedingungen ist die Lieferung auf eigener Achse nur mit Winterrädern möglich.
    </p>
  </div>
</template>

<script>

export default {
  props: ['order'],
  computed: {
    privateBuyer() {
      return (this.order.private_buyer ? 'private' : 'comercial') || '';
    },
    commercialBuyer() {
      return this.privateBuyer == 'comercial';
    },
    price() {
      if (this.commercialBuyer) {
        return this.order.car_info.online_offer_services.all_services_b2b.delivery.standard;
      }
      return this.order.car_info.online_offer_services.all_services.delivery.standard;
    },
  },
};
</script>
